import classNames from 'classnames';
import { BaseCheckbox } from 'shared/ui/Checkbox';

interface GroupCheckboxProps {
  className?: string;
  children: JSX.Element | string;
  onClick: () => void;
  isChecked: boolean;
  name: string;
  isDisabled?: boolean;
}

export function GroupCheckbox({ className, children, onClick, isChecked, name, isDisabled }: GroupCheckboxProps) {
  return (
    <div className={classNames('flex justify-start items-center', className)}>
      <BaseCheckbox
        onChange={onClick}
        isChecked={isChecked}
        controlledProps={{ name, checked: isChecked }}
        isDisabled={isDisabled}
        iconClassName={isDisabled ? 'text-slate-200' : ''}
      />
      <div className="select-none">{children}</div>
    </div>
  );
}
